import React, { useState, useEffect, useRef, useCallback } from "react";
import DynamicTable from "../../../components/admin/Table";
import { useParams } from "react-router-dom";
import Spinner from "../../../components/UI/Spinner";
import ErrorModal from "../../../components/UI/Error";
import { transactionService } from "../../../services";

const Transactions = () => {
  const [tableData, setTableData] = useState([]);
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [hasMore, setHasMore] = useState(true);
  const [pageLoading, setPageLoading] = useState(true);
  const [error, setError]= useState(false)
  const [errorMessage, setErrorMessage]= useState(false)
  const { subCat } = useParams();

  const columns = [
    "subscriber",
    "plan",
    "amount",
    "date",
    subCat === "all" ? "status" : null,
  ];
 
  // Function to fetch data from the API.
  const fetchData = async (pageNumber) => {
    setLoading(true);
    try {
      let query = ``;
      if (subCat !== "all") {
        query = subCat === "new" ? "?status=new" : "?status=seen";
      }
      const response = await transactionService.allTransactions(query);
      const allTransactions=response.map((transaction) => ({
       ...transaction,
       plan:transaction.plan?.name || "Deleted Plan",
       subscriber: transaction.subscriber?.username || "Deleted User",
      date:transaction.createdAt.split("T")[0]
      }))
      setTableData(allTransactions);

      //   // Replace this URL with your actual API endpoint.
      //   const response = await fetch(`https://your-api.com/data?page=${pageNumber}`);
      //   const newData = await response.json();
      //setTableData(data);
      //   if (newData.length === 0) {
      //     setHasMore(false);
      //   } else {
      //     setTableData((prev) => [...prev, ...newData]);
      //   }
    } catch (error) {
      console.error("Error fetching data:", error);
      setError(true)
    }finally{
      setPageLoading(false)
    }
    setLoading(false);
  };

  // Load initial data on component mount.
  useEffect(() => {
    fetchData(page);
  }, [subCat]);

  // Set up the Intersection Observer to detect when the last row is visible.
  const observer = useRef();
  const lastRowRef = useCallback(
    // (node) => {
    //   if (loading) return;
    //   if (observer.current) observer.current.disconnect();

    //   observer.current = new IntersectionObserver((entries) => {
    //     if (entries[0].isIntersecting && hasMore) {

    //       const nextPage = page + 1;
    //       setPage(nextPage);
    //       fetchData(nextPage);
    //     }
    //   });
    //   if (node) observer.current.observe(node);
    // },
    [loading, hasMore, page]
  );

  const handleMarkSeen = async (transaction) => {
    console.log(transaction._id)
    const transactions = [...tableData];
setErrorMessage(null)
try {
      const updatedTransaction = { ...transaction, status: "seen" };
      const updatedTransactions = transactions.map((obj) =>
        obj._id === updatedTransaction._id ? updatedTransaction : obj
      );
      setTableData(updatedTransactions);

      await transactionService.markTransactionSeen(transaction._id, {status:"seen"});
    } catch (error) {
      setError(true)
      setErrorMessage({title:"Updating Status", message:"update this transaction status"})
      setTableData(transactions);
      console.log(error);
    }
  };

  const tableTitle = subCat + " Transactions";

  const actionsMenu = {
  markSeen:true,
  edit:true,
  delete:true,
  };

  if(pageLoading) return <div className="grid place-content-center h-[60vh]"><Spinner/></div>
  if(error) return <ErrorModal isOpen={error} onClose={()=>setError(false)} title={`Error ${errorMessage?.title || "Fetching Transactions"} `} message={`There is error while trying to ${setErrorMessage?.message || "fetch the transaction lists"}. Please check your internet contivities and refresh this page to try again`} />
  
  return (
    <>
      {pageLoading ? (
        <div className="grid place-items-center min-h-[100vh]">
          {" "}
          <Spinner />
        </div>
      ) : (
        <div className="p-4 bg-gray-300 mix-blend-multiply h-full min-h-[100vh]">
          <h1 className="text-xl capitalize font-bold mb-4">{tableTitle}</h1>

          <div className="overflow-x-auto">
            <DynamicTable
              columns={columns}
              data={tableData}
              onMarkSeen={handleMarkSeen}
              url={"-transaction"}
              actionsMenu={actionsMenu}
              //   lastRowRef={lastRowRef}
            />
          </div>
          {loading && (
            <div className="flex justify-center mt-4">
              <div
                className="w-8 h-8 border-4 border-blue-500 border-dotted rounded-full animate-spin"
                role="status">
                <span className="sr-only">Loading...</span>
              </div>
            </div>
          )}
          {!hasMore && (
            <div className="text-center text-gray-500 mt-4">
              No more data to load.
            </div>
          )}
        </div>
      )}
    </>
  );
};

export default Transactions;
